<template>
  <div class="myMain">
    <el-dialog
      @close="close"
      append-to-body
      :visible.sync="dialogVisible">
      <template>
        <div class="publicConsultation">
          <div class="title" v-if="['zh', 'en'].includes($i18n.locale)">
            <span>{{$t('publicConsultation.title1')}}</span>
            <span class="active">{{$t('publicConsultation.title2')}}</span>
            <span>{{$t('publicConsultation.title3')}}</span>
          </div>
          <div class="title" v-if="['es', 'id'].includes($i18n.locale)">
            <span>{{$t('publicConsultation.title3')}}</span>
            <span>{{$t('publicConsultation.title1')}}</span>
            <span class="active">{{$t('publicConsultation.title2')}}</span>
          </div>
          <el-form
            ref="form"
            :model="form"
            :rules="rules">
            <div class="left">
              <el-form-item prop="productActive">
                <template slot="label">
                  <span class="checkTitle">
                    {{$t('publicConsultation.productGroup')}}
                  </span>
                </template>
                <div class="checkGroup">
                  <div
                    :class="{checkItemActive: form.productActive.includes(item.id)}"
                    class="checkItem"
                    @click="changeProduct(item.id)"
                    v-for="(item, index) in checkList"
                    :key="index">
                    <div class="info">
                      <img :src="item.icon" alt="">
                      <span>{{$t(`publicConsultation.${item.name}`)}}</span>
                    </div>
                    <div class="select">
                      <img v-if="!form.productActive.includes(item.id)" src="@/assets/PC/publicConsultation/default.png" alt="">
                      <img v-else src="@/assets/PC/publicConsultation/acitive.png" alt="">
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div class="right">
              <el-form-item prop="companyName">
                <template slot="label">
                  <span class="checkTitle">{{$t('publicConsultation.form.companyName')}}</span>
                </template>
                <el-input
                  v-model="form.companyName"
                  :placeholder="$t('el.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item prop="contactPersonName">
                <template slot="label">
                  <span class="checkTitle">{{$t('publicConsultation.form.contactPersonName')}}</span>
                </template>
                <el-input
                  v-model="form.contactPersonName"
                  :placeholder="$t('el.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item prop="contactPersonPhone">
                <template slot="label">
                  <span class="checkTitle">{{$t('publicConsultation.form.contactPersonPhone')}}</span>
                </template>
                <el-input
                  v-model="form.contactPersonPhone"
                  :placeholder="$t('el.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item prop="descriptionOfNeeds">
                <template slot="label">
                  <span class="checkTitle">{{$t('publicConsultation.form.descriptionOfNeeds')}}</span>
                </template>
                <el-input
                  type="textarea"
                  v-model="form.descriptionOfNeeds"
                  :placeholder="$t('el.pleaseEnter')"></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="submitTip" @click="isConfirm = !isConfirm">
            <div class="imgs">
              <img v-if="!isConfirm" src="@/assets/PC/publicConsultation/default.png" alt="">
              <img v-else src="@/assets/PC/publicConsultation/acitive.png" alt="">
            </div>
            <span>{{$t('publicConsultation.submitTip')}}</span>
          </div>
          <div class="submitBtn" @click="submit">{{$t('el.submit')}}</div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import rules from '@/rules'
export default {
  data () {
    return {
      rules,
      dialogVisible: true,
      checkList: [
        {
          name: 'item1',
          icon: require('@/assets/PC/publicConsultation/checkItem-AI-Ads.png'),
          id: 1
        },
        {
          name: 'item2',
          icon: require('@/assets/PC/publicConsultation/checkItem-EKYC.png'),
          id: 2
        },
        {
          name: 'item3',
          icon: require('@/assets/PC/publicConsultation/checkItem-Luna-AI-Robot.png'),
          id: 3
        },
        {
          name: 'item4',
          icon: require('@/assets/PC/publicConsultation/checkItem-Anti-Fraud-Services.png'),
          id: 4
        },
        {
          name: 'item5',
          icon: require('@/assets/PC/publicConsultation/checkItem-Credit-Scoring-Services.png'),
          id: 5
        }
      ],
      form: {
        productActive: [],
        companyName: '',
        contactPersonName: '',
        contactPersonPhone: '',
        descriptionOfNeeds: ''
      },
      isConfirm: true
    }
  },
  methods: {
    changeProduct (id) {
      const activeIndex = this.form.productActive.indexOf(id)
      if (activeIndex === -1) {
        this.form.productActive.push(id)
      } else {
        this.form.productActive.splice(activeIndex, 1)
      }
    },
    submit () {
      this.$refs.form.validate(async (valid) => {
        if (valid && this.isConfirm) {
          let productText = 'Products: '
          this.form.productActive.forEach((item, indx) => {
            this.checkList.forEach((subItem, subIndex) => {
              if (item === subItem.id) {
                productText = productText + `${this.$t(`publicConsultation.item${subItem.id}`)} / `
              }
            })
          })
          const companyName = `Company Name: ${this.form.companyName}`
          const contactPersonName = `Name: ${this.form.contactPersonName}`
          const contactPersonPhone = `Phone: ${this.form.contactPersonPhone}`
          const descriptionOfNeeds = `Needs: ${this.form.descriptionOfNeeds}`
          const emailBody =
          `
            ${productText}\n
            ${companyName}\n
            ${contactPersonName}\n
            ${contactPersonPhone}\n
            ${descriptionOfNeeds}
          `
          const subject = 'Consult products and services of CloudunAI'
          const mailLink = `mailto:operation@cloudun.ai?subject=${subject}&body=` + encodeURIComponent(emailBody)
          window.location.href = mailLink
          this.close()
        }
      })
    },
    close () {
      this.form = {
        productActive: [],
        companyName: '',
        contactPersonName: '',
        contactPersonPhone: '',
        descriptionOfNeeds: ''
      }
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-dialog {
  border-radius: 0.4rem;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
}
.publicConsultation {
  border-radius: 0.4rem;
  padding-bottom: 0.6rem;
  .title {
    font-weight: 700;
    background-image: url('@/assets/PC/publicConsultation/publicConsultation-bgi.png');
    background-size: cover;
    background-position: center;
    border-radius: 0.4rem 0.4rem 0 0;
    padding: 0.6rem 0;
    text-align: center;
    span {
      font-size: 0.64rem;
      color: #242B2A;
    }
    .active {
      color: #07816A;
    }
  }
  .el-form {
    display: flex;
    align-items: stretch;
    width: 100%;
    .left,
    .right {
      width: 50%;
      margin-top: 0.6rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .left {
      padding-left: 35px;
    }
    .right {
      padding: 0 30px;
    }
  }
}
/deep/ .el-form-item__label {
  color: #242B2A;
  font-size: 0.4rem;
  font-weight: 500;
  text-align: left;
  width: 100%;
}
.checkGroup {
  .checkItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #F3F3F3;
    border-radius: 0.8rem;
    padding: 0.08rem;
    padding: 0.08rem 0.2rem 0.08rem 0.08rem;
    margin-top: 0.4rem;
    cursor: pointer;
    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: left;
      img {
        width: 0.96rem;
        height: 0.96rem;
        margin-right: 0.24rem;
      }
      span {
        color: #242B2A;
        font-size: 0.32rem;
        font-weight: 400;
      }
    }
    .select {
      display: flex;
      align-items: center;
      img {
        width: 0.4rem;
        height: 0.4rem;
      }
    }
  }
  .checkItemActive {
    border: 1px solid #07816A;
  }
}
/deep/ .el-input__inner {
  border: 1px solid #F3F3F3;
  border-radius: 0.8rem;
  height: 1.12rem;
  &::placeholder {
    color: rgba(36, 43, 42, 0.2);
    font-size: 16px;
  }
}
/deep/ .el-textarea__inner {
  border: 1px solid #F3F3F3;
    &::placeholder {
    color: rgba(36, 43, 42, 0.2);
    font-size: 16px;
  }
}

.submitTip {
  display: flex;
  padding: 0 0.6rem 0 1.2rem;
  margin: 0.4rem 0;
  cursor: pointer;
  .imgs {
    margin-right: 0.14rem;
    img {
      width: 0.42rem;
      height: 0.42rem;
    }
  }
  span {
    color: rgba(36, 43, 42, 0.20);
    font-size: 0.28rem;
    text-align: left;
  }
}
.submitBtn {
  height: 1.28rem;
  background-color: #242B2A;
  border-radius: 0.64rem;
  padding: 0.34rem 1.54rem;
  display: table;
  color: #FFFFFF;
  font-size: 0.4rem;
  font-weight: bold;
  margin: 0 auto;
}
/deep/ .el-icon-close:before {
  content: '';
  background-image: url('@/assets/PC/publicConsultation/closeIcon.png');
  background-size: contain;
  display: inline-block;
  width: 0.6rem;
  height: 0.6rem;
}
</style>
